// extracted by mini-css-extract-plugin
export default {"root":"LessonRenderer_root__85PaG","title":"LessonRenderer_title__IBRY1","accordion":"LessonRenderer_accordion__iRUmM","copyButton":"LessonRenderer_copyButton__A-uJY"};